import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';

const PolicyEndDateSection = ({ data }) => {
  const policyEndDate = data?.policyEndDate;

  const oldValue = policyEndDate?.oldValue?.trim();
  const newValue = policyEndDate?.newValue?.trim();
  const extensionDays = policyEndDate?.extensionPeriodInDays;

  if (!oldValue && !newValue) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        border: '1px solid #d9d9d9',
        mb: 2,
        overflow: 'hidden',
        borderRadius: 0,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          backgroundColor: '#5569ff',
          color: '#fff',
          px: '8px',
          py: '4px',
        }}
      >
        Policy End Date
      </Box>

      {/* Content */}
      <Box sx={{ px: 2, py: 2 }}>
        <Grid container spacing={2}>
          {/* Heading Row */}
          {oldValue && (
            <Grid item xs={4}>
              <Typography variant="body2" fontWeight="bold">
                Old Value
              </Typography>
            </Grid>
          )}

          {newValue && (
            <Grid item xs={4}>
              <Typography variant="body2" fontWeight="bold">
                New Value
              </Typography>
            </Grid>
          )}

          {extensionDays !== undefined && extensionDays !== null && (
            <Grid item xs={4}>
              <Typography variant="body2" fontWeight="bold">
                {extensionDays < 0 ? 'Reduced By' : 'Extended By'}
              </Typography>
            </Grid>
          )}

          {/* Value Row */}
          {oldValue && (
            <Grid item xs={4}>
              <Typography>{oldValue}</Typography>
            </Grid>
          )}

          {newValue && (
            <Grid item xs={4}>
              <Typography>{newValue}</Typography>
            </Grid>
          )}

          {extensionDays !== undefined && extensionDays !== null && (
            <Grid item xs={4}>
              <Typography
                sx={{
                  color: extensionDays < 0 ? 'error.main' : 'success.main',
                }}
              >
                {Math.abs(extensionDays)} days
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>
    </Paper>
  );
};

export default PolicyEndDateSection;